import { useTranslation } from 'react-i18next';

export const useGetFormattedContentDuration = () => {
  const { t } = useTranslation();

  const getFormattedContentDuration = (duration: number | undefined | null) => {
    if (!duration) return '';

    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);

    if (hours === 0 && minutes <= 1) return t('contentDuration.lessThanAMinute');

    // Handle different combinations with conditional translations
    if (hours > 0 && minutes === 0) {
      // Only hours, no minutes
      return hours === 1
        ? t('contentDuration.hourMinute', { hours })
        : t('contentDuration.hoursMinute', { hours });
    }

    if (hours > 0 && minutes > 0) {
      // Both hours and minutes
      return hours === 1
        ? t('contentDuration.hourMinutes', { hours, minutes })
        : t('contentDuration.hoursMinutes', { hours, minutes });
    }

    // Only minutes (more than 1)
    return t('contentDuration.minutesOnly', { minutes });
  };

  return { getFormattedContentDuration };
};
